import { render, staticRenderFns } from "./ReviewList.vue?vue&type=template&id=4ca683bf&scoped=true&"
import script from "./ReviewList.vue?vue&type=script&lang=js&"
export * from "./ReviewList.vue?vue&type=script&lang=js&"
import style0 from "./ReviewList.vue?vue&type=style&index=0&id=4ca683bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca683bf",
  null
  
)

export default component.exports